import { makeHeadingPropsSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import {
  combinedStyleSelector,
  getSettingValueSelector,
  makeEntityChildrenIdsSelector,
  TargetSelector
} from "@client/selectors";
import { type AppState } from "@client/types";
import { updateQueryString } from "@common/lib/url";
import { localStateSelector } from "../selectors";
import Component, { type MapProps } from "./component";

type Props = Omit<
  MapProps,
  | "childrenIds"
  | "package"
  | "priceHeadingProps"
  | "priceMode"
  | "priceSettings"
  | "style"
  | "titleHeadingProps"
  | "trialPagePath"
> &
  RootContainerProps;
const makeMapStateToProps = () => {
  const childrenIdsSelector = makeEntityChildrenIdsSelector();
  const priceModeSelector = getSettingValueSelector(TargetSelector.Entity, "priceMode");
  const styleSelector = combinedStyleSelector(TargetSelector.Entity, ["border", "boxShadow", "padding"], "blocks");
  const titleHeadingPropsSelector = makeHeadingPropsSelector(TargetSelector.Entity, "price.title");
  const priceHeadingPropsSelector = makeHeadingPropsSelector(TargetSelector.Entity, "price.price");

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    const style = styleSelector(state, props)!;

    return {
      ...props,
      childrenIds: childrenIdsSelector(state, props),
      package: localState.package!,
      priceMode: priceModeSelector(state, props),
      priceHeadingProps: priceHeadingPropsSelector(state, props),
      style,
      titleHeadingProps: titleHeadingPropsSelector(state, props),
      trialPagePath: updateQueryString(localState.trialPagePath, {
        p: localState.package!.code,
        t: localState.trial?.code,
        f: props.frequency
      })
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
